// Shared icon components. All icons use currentColor unless a specific color is required.

export function ChevronLeft() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11L5 7l4-4" />
    </svg>
  )
}

export function ChevronDown() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 4l4 4 4-4" />
    </svg>
  )
}

export function ThumbUp() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6.5V12M2 7.5h2l1-4.5a1 1 0 0 1 2 0v3h3.5a1 1 0 0 1 .97 1.24l-.8 3.5A1 1 0 0 1 9.7 12H4" />
    </svg>
  )
}

export function ThumbDown() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 7.5V2M12 6.5h-2L9 11a1 1 0 0 1-2 0V8H3.5a1 1 0 0 1-.97-1.24l.8-3.5A1 1 0 0 1 4.3 2H10" />
    </svg>
  )
}

export function PanelToggleIcon({ collapsed }: { collapsed: boolean }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      {collapsed ? <path d="M9 3l-4 4 4 4" /> : <path d="M5 3l4 4-4 4" />}
    </svg>
  )
}

export function DownloadIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 2v7M4 6l3 3 3-3M2 11h10" />
    </svg>
  )
}

export function DotsThreeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
      <circle cx="7" cy="3" r="1.2" />
      <circle cx="7" cy="7" r="1.2" />
      <circle cx="7" cy="11" r="1.2" />
    </svg>
  )
}

export function UploadIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 11V4M4 7l3-3 3 3M2 11h10" />
    </svg>
  )
}

export function CheckCircleIcon({ size = 20 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 12.75 11.25 15 15 9.75" />
      <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  )
}

export function CloseIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round">
      <path d="M3 3l10 10M13 3L3 13" />
    </svg>
  )
}

export function CalendarIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1.5" y="2.5" width="11" height="10" rx="1.5" />
      <path d="M1.5 5.5h11M4.5 1.5v2M9.5 1.5v2" />
    </svg>
  )
}

export function ClockIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7" cy="7" r="5.5" />
      <path d="M7 4v3l2 2" />
    </svg>
  )
}

export function ArrowUpRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 11L11 5M5 5h6v6" />
    </svg>
  )
}

export function ChevronRight() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 4l4 4-4 4" />
    </svg>
  )
}

export function ClipboardIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="2.5" width="8" height="10" rx="1" />
      <path d="M5 1.5h4v2H5z" />
    </svg>
  )
}

export function MessageIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H6l-3 2.5v-2.5H3a1 1 0 0 1-1-1z" />
    </svg>
  )
}

export function MoreVerticalIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7" cy="3" r="0.6" fill="currentColor" />
      <circle cx="7" cy="7" r="0.6" fill="currentColor" />
      <circle cx="7" cy="11" r="0.6" fill="currentColor" />
    </svg>
  )
}

export function ChevronsRight({ direction = 'right' }: { direction?: 'right' | 'left' } = {}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" style={{ transform: direction === 'left' ? 'scaleX(-1)' : undefined }}>
      <path d="M4 4l4 4-4 4M8 4l4 4-4 4" />
    </svg>
  )
}

export function PhasesIcon() {
  // 4-rect phase glyph, used in Kanban Suggested header
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="2.4" height="6" rx="0.5" />
      <rect x="5.5" y="4" width="2.4" height="8" rx="0.5" />
      <rect x="9" y="2.5" width="2.4" height="9.5" rx="0.5" />
      <rect x="12.5" y="5" width="2.4" height="7" rx="0.5" />
    </svg>
  )
}

export function ExclamationIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 2L1.5 13.5h13L8 2z" />
      <path d="M8 6.5v3.5M8 12h.01" />
    </svg>
  )
}

// Variant of ExclamationIcon for inline use inside addons. Stroke is currentColor,
// callers pick the color via the wrapping element.
export function AlertTriangleIcon({ size = 14 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 1.5 L0.875 11.8 H13.125 Z" />
      <path d="M7 5.5v3" />
      <path d="M7 10.25v0.25" />
    </svg>
  )
}

export function PaperclipIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 6.5L6 11.5a2.5 2.5 0 0 1-3.5-3.5l5.5-5.5a1.7 1.7 0 0 1 2.4 2.4L4.9 10.4a0.85 0.85 0 0 1-1.2-1.2L8.5 4.5" />
    </svg>
  )
}

// Feather "activity" — heart-rate line. Used in the Engagement addon to flag
// "Last Engaged" (see C_care-kanban-design-spec.md §16, Figma 40005215:8531).
export function PulseIcon({ size = 14 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 7h2.5L5 3l2 8 2-6 1.5 2H13" />
    </svg>
  )
}

// Feather "award" — medal + ribbon tails. Used in the Engagement addon for the
// 30-day count line (see C_care-kanban-design-spec.md §16, Figma 40005215:11142).
export function AwardIcon({ size = 14 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7" cy="5.5" r="3.5" />
      <path d="M4.7 8.4 4 13l3-1.6L10 13l-.7-4.6" />
    </svg>
  )
}

export function PlusIcon({ size = 10, strokeWidth = 0.9 }: { size?: number; strokeWidth?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2v8M2 6h8" />
    </svg>
  )
}

export function CheckIcon({ size = 15 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12.5 4 6 10.5 2.75 7.25" />
    </svg>
  )
}

export function FileIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 1.5h5l3 3V12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2.5a1 1 0 0 1 1-1z" />
      <path d="M8 1.5V4a1 1 0 0 0 1 1h2" />
    </svg>
  )
}

export function UserIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7" cy="5" r="2.5" />
      <path d="M2.5 12.5a4.5 4.5 0 0 1 9 0" />
    </svg>
  )
}

export function GridIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="4" height="4" rx="0.5" />
      <rect x="8" y="2" width="4" height="4" rx="0.5" />
      <rect x="2" y="8" width="4" height="4" rx="0.5" />
      <rect x="8" y="8" width="4" height="4" rx="0.5" />
    </svg>
  )
}

export function BarChartIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12.5V6M7 12.5V1.5M12 12.5V8.5" />
    </svg>
  )
}

export function LockIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 14 14" fill="none" stroke="#BCC7D7" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="10" height="7" rx="2" />
      <path d="M4.5 6V4a2.5 2.5 0 0 1 5 0v2" />
    </svg>
  )
}

// Square-with-pen "edit" glyph. Sits beside the instruction line in the Care
// Block Detail drawer header.
export function PencilIcon({ size = 13 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2.2a1.4 1.4 0 0 0-2 0L4.3 7.9 3.6 10.4l2.5-.7L11.8 4a1.4 1.4 0 0 0 .2-1.8Z" />
      <path d="M11.8 8.6v2.6a1.3 1.3 0 0 1-1.3 1.3H2.8a1.3 1.3 0 0 1-1.3-1.3V3.5a1.3 1.3 0 0 1 1.3-1.3h2.7" />
    </svg>
  )
}

// Lightning bolt — flags a med list entry that arrived via e-prescribing.
export function ZapIcon({ size = 12 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="currentColor">
      <path d="M7.8 1 2.5 8h3.2l-.7 5L10.5 6H7.2z" />
    </svg>
  )
}

// Small pennant/flag — marks the patient-facing instructions block in an
// expanded Pharmacy tab row.
export function FlagPennantIcon({ size = 13 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 1.5v11" />
      <path d="M3 2.2h7.5l-2 2.4 2 2.4H3" />
    </svg>
  )
}

// Ayble's four-bar mark — the avatar and tag glyph on Ayble AI feed entries.
// Redrawn from the brand mark by eye; swap for the brand asset when there is one.
export function AybleMarkIcon({ size = 14 }: { size?: number } = {}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <rect x="4.5" y="8" width="2.6" height="9" rx="1.3" />
      <rect x="9" y="5" width="2.6" height="11" rx="1.3" />
      <rect x="13.5" y="8.5" width="2.6" height="10.5" rx="1.3" />
      <rect x="18" y="6.5" width="2.6" height="9.5" rx="1.3" />
    </svg>
  )
}
